import React, { useState } from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import customTheme from './theme'

const CACHE_KEY = 'IS_DARK'

export interface ThemeContextType {
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = React.createContext<ThemeContextType>({ isDark: false, toggleTheme: () => null })

const ThemeContextProvider: React.FC = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    // const isDarkUserSetting = localStorage.getItem(CACHE_KEY)
    // return isDarkUserSetting ? JSON.parse(isDarkUserSetting) : false
    return true;
  })

  const toggleTheme = () => {
    setIsDark((prevState: any) => {
      localStorage.setItem(CACHE_KEY, JSON.stringify(!prevState))
      return !prevState || true;
    })
  }

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {/* <SCThemeProvider theme={isDark ? dark : light}>{children}</SCThemeProvider> */}
      <SCThemeProvider theme={customTheme}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeContextProvider }
